import { render, staticRenderFns } from "./StockListOnPlate.vue?vue&type=template&id=61e37cd9&scoped=true"
import script from "./StockListOnPlate.vue?vue&type=script&lang=js"
export * from "./StockListOnPlate.vue?vue&type=script&lang=js"
import style0 from "./StockListOnPlate.vue?vue&type=style&index=0&id=61e37cd9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e37cd9",
  null
  
)

export default component.exports